<template>
	<aside class="gdpr-banner" v-if="opened">
		<Gdpr
			ref="gdpr"
			:opened="openModal"
			@close="close"/>

		<div class="gdpr-banner__text">
			Nous utilisons des cookies pour garantir le fonctionnement du site.
		</div>

		<div class="gdpr-banner__buttons">
			<LmdtButton classes="gdpr-banner__disable" @click="disableAll">
				Tout refuser
			</LmdtButton>

			<LmdtButton classes="gdpr-banner__disable" @click="enableAll">
				Tout accepter
			</LmdtButton>

			<LmdtButton classes="gdpr-banner__tweak" @click="open">
				Modifier
			</LmdtButton>

			<LmdtButton classes="gdpr-banner__accept" @click="save">
				OK
			</LmdtButton>
		</div>
	</aside>
</template>

<script>
	import Gdpr from "@/components/Gdpr"
	import LmdtButton from "@/components/LmdtButton"

	export default {
		props: {},
		components: {
			Gdpr,
			LmdtButton,
		},
		data(){
			return {
				opened: !this.$gdpr_serde.exists(),
				openModal: false,
			}
		},
		methods: {
			save(){
				this.$refs.gdpr.save();
			},
			open(){
				this.$gdpr_serde.check();
				this.opened = true;
				this.openModal = true;
			},
			close(){
				this.opened = false;
				this.openModal = false;
			},
			enableAll(){
				this.$refs.gdpr.enableAll();
				this.save();
			},
			disableAll(){
				this.$refs.gdpr.disableAll();
				this.save();
			},
		},
	}
</script>

<style lang="scss">
	@use "~@scss/components/GdprBanner" as *;
</style>
